/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Represents the severity of a validation issue.
 */
export let ValidationSeverity = /*#__PURE__*/function (ValidationSeverity) {
  ValidationSeverity["WARNING"] = "warning";
  ValidationSeverity["ERROR"] = "error";
  ValidationSeverity["FATAL_ERROR"] = "fatal_error";
  ValidationSeverity["INTERNAL_ERROR"] = "internal_error";
  return ValidationSeverity;
}({});

/**
 * A simple interface representing a single validation issue for an editable item.
 */

export function isValidationIssue(obj) {
  return obj != null && typeof obj === "object" && 'severity' in obj && 'message' in obj && typeof obj.severity === 'string' && typeof obj.message === 'string';
}
//# sourceMappingURL=ValidationIssue.js.map
